import { Signup } from '@app/_models/signup';

export class PaymentVerifyRequest {
  FirstName: string;
  LastName: string;
  CCNumber: string;
  CCMonth: string;
  CCYear: string;
  CVV: string;
  HasOutstandingBalance: boolean;
  ContactID: string;
  CCAddress: string;
  CCRegion: string;
  CCCountry: string;
  CCPostal: string;
  CCCity: string;

  constructor(signup: Signup) {
    this.FirstName = signup.ccfirstname;
    this.LastName = signup.cclastname;
    this.CCNumber = signup.ccnumber;
    this.CCMonth = signup.ccmonth;
    this.CCYear = signup.ccyear;
    this.CVV = signup.ccsecuritycode;
    this.HasOutstandingBalance = signup.HasOutstandingBalance;
    this.ContactID = signup.ContactID;
    this.CCAddress = signup.ccaddress;
    this.CCRegion = signup.ccregion;
    this.CCCountry = signup.cccountry
    this.CCPostal = signup.ccpostal;
    this.CCCity = signup.cccity;
  }
}
